import { ReferentialAction, ReferentialActionToSQL } from "../constants/schema.js";
//#region src/utils/referentialAction.ts
var SEPARATOR = /[\s_]+/g;
function toReferentialAction(spelling) {
	const value = spelling.trim().replace(SEPARATOR, " ").toUpperCase();
	const entry = Object.entries(ReferentialActionToSQL).find(([, sql]) => sql === value);
	return entry ? Number(entry[0]) : ReferentialAction.none;
}
var ACTION_LETTERS = {
	[ReferentialAction.noAction]: "NA",
	[ReferentialAction.cascade]: "C",
	[ReferentialAction.setNull]: "SN",
	[ReferentialAction.setDefault]: "SD",
	[ReferentialAction.restrict]: "R"
};
function referentialActionLabel({ onDelete, onUpdate }) {
	return [ACTION_LETTERS[onDelete] ? `D:${ACTION_LETTERS[onDelete]}` : "", ACTION_LETTERS[onUpdate] ? `U:${ACTION_LETTERS[onUpdate]}` : ""].filter(Boolean).join(" ");
}
function referentialActionTitle({ onDelete, onUpdate }) {
	return [ReferentialActionToSQL[onDelete] ? `ON DELETE ${ReferentialActionToSQL[onDelete]}` : "", ReferentialActionToSQL[onUpdate] ? `ON UPDATE ${ReferentialActionToSQL[onUpdate]}` : ""].filter(Boolean).join("\n");
}
//#endregion
export { referentialActionLabel, referentialActionTitle, toReferentialAction };
